import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: { defaultMessage: 'Health factor' },
});
